import { SVGProps } from 'react'
export const PolygonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns={'http://www.w3.org/2000/svg'} width={16} height={8} fill={'none'} {...props}>
    <path stroke={'#006646'} strokeWidth={2} d={'M0 4h13'} />
    <path fill={'#006646'} d={'m16 4-4.5 3.464V.536L16 4Z'} />
  </svg>
)
